import { AxiosError, AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { SelfBookingAppointmentCreate, ErrorMessage, Appointment } from 'types';
import { client } from 'utils/api-client';

export default function useCreateSelfBookingAppointment(
  appointmentTypeId: string,
): UseMutationResult<AxiosResponse<Appointment>, AxiosError<ErrorMessage>, SelfBookingAppointmentCreate> {
  const queryClient = useQueryClient();

  const mutationFn = (payload: SelfBookingAppointmentCreate): Promise<AxiosResponse<Appointment>> => {
    return client.post(`appointment-self-booking/`, payload);
  };

  return useMutation(['appointment-type-self-booking', appointmentTypeId], mutationFn, {
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries(['appointment-type-self-booking']);
      queryClient.invalidateQueries(['appointment-type-self-booking', appointmentTypeId]);
      queryClient.invalidateQueries(['appointment-type-self-booking-coach-available-dates']);
      queryClient.invalidateQueries(['appointment-type-self-booking-available-slots']);
      queryClient.invalidateQueries(['appointment-type-self-booking-athlete-has-valid-credit-dispensation']);
      queryClient.invalidateQueries([
        [
          'appointment-type-self-booking',
          appointmentTypeId,
          payload.staff,
          dayjs(payload.startDateTime).format('YYYY-MM-DD'),
        ],
      ]);
    },
  });
}
